import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { JUser } from '@ascschool/interface/user';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthStore } from './auth.store';
import { environment } from 'src/environments/environment';
import { JSetting } from '@ascschool/interface/setting';
import { Tab } from '../../project/tabs/tab.model';
import { Router } from '@angular/router';
import { UtilsService } from '@ascschool/services/utils.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
    version = 'v1.0';
    tabs: Tab[] = [new Tab('Trang chủ', 'board')];
    navchange: EventEmitter<number> = new EventEmitter();
    private auth: JUser;
    private baseUrl: string;
    // public settings: JSetting;
    currentUserSubject: BehaviorSubject<any>;
    currentUser: Observable<any>;
    header: HttpHeaders;
    private data = {
        positionMenuNav: 'left',
        positionInfoNav: 'right',
        hiddenInfoNav: true,
        btnType: 1
    };
    constructor(
        private authStore: AuthStore,
        private http: HttpClient,
        private utils: UtilsService,
        private _store: AuthStore,
        private router: Router,
    ) {
        this.baseUrl = environment.apiUrl;
        const headerSettings: { [name: string]: string | string[] } = {};
        this.header = new HttpHeaders(headerSettings);
    }
    emitNavChangeEvent() {
        this.navchange.emit();
    }
    getNavChangeEmitter() {
        return this.navchange;
    }
    login({ email = '', password = '', browser, browser_version, device, deviceType, orientation, os, os_version, userAgent }) {
        const PasswordHash = this.utils.md5Encode(password);
        const loginInfo = {
            username: email,
            passwordHash: PasswordHash,

            browser: browser,
            browser_version: browser_version,
            device: device,
            deviceType: deviceType,

            orientation: orientation,
            os: os,
            os_version: os_version,
            userAgent: userAgent

        };
        return this.http
            .post<any>(environment.apiUrl + environment.ver + '/Authenticate/Login', loginInfo, {
                headers: this.header
            })
            .pipe(
                tap((user) => {
                    if (user && user.userInfo && user.status === 0) {
                        this.auth = user.userInfo;
                        this.auth.ver = environment.ver;
                        this.auth.settings = this.data;
                        this._store.setLoading(true);
                        this.authStore.login(this.auth);
                    }
                    this._store.setLoading(false);
                    return user;
                })
            );
    }
    getSettingInfo() {
        return this.authStore.getValue().settings;
    }
    getUserInfo() {
        return this.authStore.getValue();
    }
    getUpdateSettingInfo(settings: JSetting) {
        this.authStore.update((state) => {
            return {
                ...state,
                settings
            };
        });
        localStorage.setItem('userSetting', JSON.stringify(this.authStore.getValue()));
    }
    clearCache() {
        localStorage.removeItem('selectedIndex');
        localStorage.removeItem('tabs');
        location.reload();
    }
    refreshToken(refreshTokenModel: any) {
        return this.http.post(
            `${environment.apiUrl}${this.version}/Authenticate/Refresh`,
            refreshTokenModel
        );
    }
    logout() {
        this.authStore.logout();
        setTimeout(() => {
            location.reload();
        }, 300);
    }
}
export class LoginPayload {
    email: string;
    password: string;
    status: number;

    browser: string;
    browser_version: string;
    device: string;
    deviceType: string;

    orientation: string;
    os: string;
    os_version: string;
    userAgent: string;

    constructor(email: string, password: string, status: number,
        device: any) {
        this.email = email;
        this.password = password;
        this.status = status;
        if (device) {
            this.browser = device.browser;
            this.browser_version = device.browser_version;
            this.device = device.device;
            this.deviceType = device.deviceType;

            this.orientation = device.orientation;
            this.os = device.os;
            this.os_version = device.os_version;
            this.userAgent = device.userAgent;
        }
    }
}
